import type { CommonAction } from "@iflyrpa/share";
import { z } from "zod";
import { ActiomCommonParams, ActionCommonParamsSchema } from "../../types";
import { executeAction, formatSectionHtml } from "../../utils";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";

interface ActivityData {
    id: string;
    task_name: string;
    // biome-ignore lint/suspicious/noExplicitAny: false positive
    [key: string]: any;
}

export const BaijiahaoPublishParamsSchema = ActionCommonParamsSchema.extend({
    saveType: z.enum(["draft", "publish"]), // 保存成草稿 / 发布
    token: z.string(),
    title: z.string(),
    content: z.string(),
    proxyLoc: z.string().optional(),
    localIP: z.string().optional(), // 用户ip
    huiwenToken: z.string().optional(), // 绘文token
    settingInfo: z.object({
        baijiahaoTitle: z.string(), // 标题
        baijiahaoCoverType: z.enum(["single", "multiple"]), // 封面设置：单图 | 三图
        baijiahaoAbstract: z.string(), // 摘要
        baijiahaoIsAi: z.array(z.string()), // 设置-由配置项取代
        baijiahaoSingleCover: z.string(), // 单图封面
        baijiahaoMultCover: z.array(z.string()), // 三图封面
        baijiahaoVerticalCover: z.string().optional(), // 竖版封面-下版本删除
        baijiahaoActivity: z.array(
            z
                .object({
                    id: z.string(),
                    task_name: z.string(),
                })
                .catchall(z.any()), // 允许其他任意字段,
        ), // 活动投稿
        baijiahaoPublishConf: z
            .array(
                z.object({
                    confName: z.string(),
                    isChecked: z.boolean(),
                }),
            )
            .optional(), // 发布配置项
        baijiahaoTopic: z.record(z.string(), z.any()).optional(), // 百家号话题
        baijiahaoCms: z.array(z.string()).optional(), // 百家号分类
        baijiahaoEventSpec: z
            .object({
                time: z.string(),
                pos: z.string(),
            })
            .partial()
            .optional(), // 百家号事件来源说明
        baijiahaoEvent2News: z.boolean(), // 图文转动态
        baijiahaoSelectActivityCache: z.array(z.string()), // 选中的活动标签
        timer: z.number().optional(),
    }),
});

export type BaijiahaoPublishParams = ActiomCommonParams & z.infer<typeof BaijiahaoPublishParamsSchema>;

export type PublishAction = CommonAction<BaijiahaoPublishParams, string>;

export const baijiahaoPublish: PublishAction = async (task, params) => {
    task.logger.info(`baijiahaoPublish actionType: ${params.actionType}`);
    // Format content HTML
    params.content = formatSectionHtml(params.content);

    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    return executeAction(mockAction, rpaAction)(task, params);
};
